import React from 'react'

export const Preloader = () => {
  return (
    <div className='progress'>
      <div className='indeterminate'></div>
    </div>
  )
}